import { render, staticRenderFns } from "./StudentsDashboard.vue?vue&type=template&id=56e7c99e&scoped=true&"
import script from "./StudentsDashboard.vue?vue&type=script&lang=js&"
export * from "./StudentsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StudentsDashboard.vue?vue&type=style&index=0&id=56e7c99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7c99e",
  null
  
)

export default component.exports